const PARENT_CATEGORIES = ['Physique', 'Effluences', 'Autres'];
const CATEGORIES = [
    { label: "Alimentaire", parent: PARENT_CATEGORIES[0], ref: "AL"},
    { label: "Composant Cellulaire", parent: PARENT_CATEGORIES[0], ref: "CC" },
    { label: "Environnemental", parent: PARENT_CATEGORIES[0], ref: "EN" },
    { label: "Pathogène", parent: PARENT_CATEGORIES[0], ref: "PA" },
    { label: "Pharmaceutique", parent: PARENT_CATEGORIES[0], ref: "PH" },
    { label: "Sens", parent: PARENT_CATEGORIES[0], ref: "SE" },
    { label: "Organique", parent: PARENT_CATEGORIES[0], ref: "OR" },
    { label: "Cristaux", parent: PARENT_CATEGORIES[1], ref: "C" },
    { label: "Emotions", parent: PARENT_CATEGORIES[1], ref: "E" },
    { label: "Fleurs", parent: PARENT_CATEGORIES[1], ref: "F" },
    { label: "Méridiens", parent: PARENT_CATEGORIES[2], ref: "MR" },
    { label: "Relationnel", parent: PARENT_CATEGORIES[2], ref: "RE" },
    { label: "Situationnel", parent: PARENT_CATEGORIES[2], ref: "SI" },
    { label: "Divers", parent: PARENT_CATEGORIES[2], ref: "DI" },
]

const getCategories = () => {
    return CATEGORIES;
}

const getCategoriesByParent = (parent) => {
    if(!PARENT_CATEGORIES.includes(parent))
        throw new Error(`Parent category ${parent} not found`);

    return CATEGORIES.filter(category => category.parent === parent);
}

const getParentCategories = () => {
    return PARENT_CATEGORIES;
}

const getRefFromCategory = (category) => {
    return CATEGORIES.find(c => c.label === category).ref;
}

export default {
    getCategories,
    getCategoriesByParent,
    getParentCategories,
    getRefFromCategory
}
